import { render } from "./BankAccountsContainer.vue?vue&type=template&id=7752d402"
import script from "./BankAccountsContainer.vue?vue&type=script&lang=js"
export * from "./BankAccountsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__